import { Component } from "react";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import $ from "jquery";
import { adminlimit, downloadUrl } from "../Settings/Config";
import api from "../../utils/axios";
import { showContaimerLoader, showStatus, encodeValue, removeItem, showPageCount, hasPermission, addModule } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const module = "vessel";
const modulePath = "/vessel";
const moduleName = "Vessel";
const moduleID = 4;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      filterCompany: "",
      companyList: [],
      viewVesselName: "",
      viewImages: [],
      viewParticulars: [],
      activeMediaTab: "images",
      currentImageIndex: 0,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadList(1);
      this.loadCompany();
    }
  }

  loadCompany() {
    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    if (this.state.filterCompany !== null && Object.keys(this.state.filterCompany).length > 0) {
      addParams += "&filterCompany=" + this.state.filterCompany.value;
    }

    const params = {
      params: "limit=" + this.state.pageLimit.value + "&offset=" + offset + addParams,
      url: `${module}`,
    };
    this.props.getListData(params);
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `${modulePath}/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      if (this.state.currentPage !== value) {
        this.setState(
          {
            loading: true,
            currentPage: value,
          },
          () => {
            this.loadList(value);
          },
        );
      }
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  parseImages(item) {
    const raw = item?.vesselImages || "";
    return raw !== "" && raw !== null
      ? raw
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s !== "")
      : [];
  }
  parseParticulars(item) {
    const raw = item?.vesselParticulars || "";
    if (raw === "" || raw === null) return [];
    try {
      return JSON.parse(raw) || [];
    } catch (e) {
      return [];
    }
  }
  viewVessel(item, e) {
    e.preventDefault();
    const images = this.parseImages(item);
    const particulars = this.parseParticulars(item);
    this.setState(
      {
        viewVesselName: item.vesselName,
        viewImages: images,
        viewParticulars: particulars,
        activeMediaTab: images.length > 0 ? "images" : "particulars",
        currentImageIndex: 0,
      },
      () => {
        $("#vesselMediaTrigger").trigger("click");
      },
    );
  }
  closeVesselMedia = () => {
    this.setState({ viewVesselName: "", viewImages: [], viewParticulars: [], activeMediaTab: "images", currentImageIndex: 0 });
  };
  setActiveMediaTab = (tab) => {
    this.setState({ activeMediaTab: tab });
  };
  prevImage = () => {
    this.setState((prev) => ({ currentImageIndex: prev.currentImageIndex === 0 ? prev.viewImages.length - 1 : prev.currentImageIndex - 1 }));
  };
  nextImage = () => {
    this.setState((prev) => ({ currentImageIndex: (prev.currentImageIndex + 1) % prev.viewImages.length }));
  };
  openParticular = (pathName, e) => {
    e.preventDefault();
    window.open(`${downloadUrl}uploads/vesselparticulars/${pathName}`, "_blank");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  {addModule(moduleID, moduleName, modulePath)}
                  <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#vesselMediaModal" data-backdrop="static" data-keyboard="false" id="vesselMediaTrigger">
                    &nbsp;
                  </button>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                            </div>
                            <div className="col-md-3">
                              <Select
                                value={this.state.filterCompany}
                                onChange={this.handleSelectChange.bind(this, "filterCompany")}
                                placeholder="Select Company"
                                isClearable={true}
                                options={this.state.companyList}
                              />
                            </div>

                            <div className="col-md-2">
                              <Select
                                value={this.state.status}
                                onChange={this.handleSelectChange.bind(this, "status")}
                                placeholder="Select Status"
                                isClearable={true}
                                options={[
                                  { value: "A", label: "Active" },
                                  { value: "I", label: "In Active" },
                                ]}
                              />
                            </div>
                            <div className="col-md-3">
                              <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                                Search
                              </a>
                              <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div>
                          <div className="card-header">
                            {parseInt(this.state.totalPage) > 0 &&
                              showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead className="table-primary">
                                  <tr>
                                    <th className="text-center">Actions </th>
                                    <th>S.No.</th>
                                    <th>Vessel Code</th>
                                    <th>Vessel Name</th>
                                    <th>company Name</th>
                                    <th>Vessel Type</th>
                                    <th>IMO Number</th>
                                    <th>Flag</th>
                                    <th>GRT</th>
                                    <th>Engine</th>
                                    <th>KWT</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.loading ? (
                                    <tr>
                                      <td colSpan={12}>{showContaimerLoader()}</td>
                                    </tr>
                                  ) : this.state.listdata.length > 0 ? (
                                    this.state.listdata.map((item, index) => {
                                      return (
                                        <tr key={index} className={`${item.vesselStatus === "I" ? "bg-danger text-white" : ""}`}>
                                          <td className="text-center text-nowrap" valign="top">
                                            {(item.vesselImages || item.vesselParticulars) && (
                                              <a href="/" onClick={this.viewVessel.bind(this, item)} className="me-2">
                                                <i className="fa fa-image"></i>
                                              </a>
                                            )}
                                            {hasPermission(moduleID, "edit") && (
                                              <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                                <i className="fa fa-pencil-square-o"></i>
                                              </a>
                                            )}
                                            {hasPermission(moduleID, "delete") && (
                                              <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                                <i className="fa fa-trash"></i>
                                              </a>
                                            )}
                                          </td>
                                          <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                          <td>{item.vesselCode}</td>
                                          <td>{item.vesselName}</td>
                                          <td>{item.company_name}</td>
                                          <td>{item.vesselType}</td>
                                          <td>{item.imoNumber}</td>
                                          <td>{item.vesselFlag}</td>
                                          <td>{item.vesselGRT}</td>
                                          <td>{item.vesselEngine}</td>
                                          <td>{item.vesselKWT}</td>
                                          <td>{showStatus(item.companyStatus)}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td className="text-center" colSpan={12}>
                                        No {moduleName} Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {parseInt(this.state.totalPage) > 1 && (
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="vesselMediaModal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewVesselName} - Media</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeVesselMedia}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <a
                      href="/"
                      className={`nav-link ${this.state.activeMediaTab === "images" ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setActiveMediaTab("images");
                      }}
                    >
                      Images {this.state.viewImages.length > 0 && `(${this.state.viewImages.length})`}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="/"
                      className={`nav-link ${this.state.activeMediaTab === "particulars" ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setActiveMediaTab("particulars");
                      }}
                    >
                      Vessel Particulars {this.state.viewParticulars.length > 0 && `(${this.state.viewParticulars.length})`}
                    </a>
                  </li>
                </ul>

                {this.state.activeMediaTab === "images" &&
                  (this.state.viewImages.length > 0 ? (
                    <div className="text-center">
                      <div style={{ position: "relative" }}>
                        {this.state.viewImages.length > 1 && (
                          <button type="button" className="btn btn-light" style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)" }} onClick={this.prevImage}>
                            <i className="fa fa-chevron-left"></i>
                          </button>
                        )}
                        <img src={`${downloadUrl}uploads/vesselimage/${this.state.viewImages[this.state.currentImageIndex]}`} alt="Vessel" style={{ maxWidth: "100%", maxHeight: "75vh" }} />
                        {this.state.viewImages.length > 1 && (
                          <button type="button" className="btn btn-light" style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }} onClick={this.nextImage}>
                            <i className="fa fa-chevron-right"></i>
                          </button>
                        )}
                      </div>
                      {this.state.viewImages.length > 1 && (
                        <div className="mt-2">
                          {this.state.currentImageIndex + 1} / {this.state.viewImages.length}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center text-muted">No Images Found</div>
                  ))}

                {this.state.activeMediaTab === "particulars" &&
                  (this.state.viewParticulars.length > 0 ? (
                    <ul className="list-group">
                      {this.state.viewParticulars.map((particular, index) => (
                        <a
                          href="/"
                          key={index}
                          className="list-group-item list-group-item-action d-flex align-items-center"
                          onClick={this.openParticular.bind(this, particular.pathName)}
                        >
                          <i className="fa fa-file-pdf-o me-2"></i>
                          {particular.fileName}
                        </a>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-center text-muted">No Vessel Particulars Found</div>
                  ))}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closeVesselMedia}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
